export enum GridActionType {
    Edit,
    Load,
    Delete,
    Copy,
    Custom
}

export interface GridActionsCellItem {
    text: string;
    icon: string;
    iconPack?: string;
    status?: string;
    classList?: Array<string>;
    isHidden?: boolean;
    isDisabled?: boolean;
    type: GridActionType;
    altText?: string;
    dropdown?: {
        menuItems: Array<{ icon?: string; type: string; title: string; hidden?: boolean }>;
    };
    isLoading?: boolean;
}
